// aiinsikt-report-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1a.report.pdfBackendUnavailable': 'El backend de PDF no está disponible.',
  'r1a.report.pdfDownloadFailed': 'No se pudo descargar el PDF.',
  'r1a.report.openingPrint': 'Abriendo la impresión …',
  'r1a.report.subtitleMonthly': 'Informe mensual · resultado',
  'r1a.report.subtitleYearly': 'Informe anual · resultado',
  'r1a.report.comparedWith': ' · comparado con {period}',
  'r1a.report.chartTitle': 'Ingresos y gastos por mes · {year}',
  'r1a.report.footnote': 'Los informes se generan a partir de movimientos contabilizados. Los ejercicios anteriores están disponibles mientras la contabilidad esté llevada. La comparación muestra el mismo periodo del año anterior.',
});
